module.exports = __webpack_public_path__ + "static/media/end-game-img.c3c3975b.svg";